import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { useSync } from "@/lib/live";
import { BookingChat } from "@/components/BookingChat";
import { StatusBadge } from "@/components/Status";
import { useDetail } from "@/admin/AdminDetail";
import { ContactButtons, Empty } from "@/admin/ui";

export const AdminChats = () => {
  const [rows, setRows] = useState([]);
  const [selId, setSelId] = useState(null);
  const open = useDetail();
  const load = useCallback(() => api.get("/admin/chats").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  useSync(load);
  const sel = rows.find((r) => r.booking_id === selId);
  return (
    <div className="grid gap-4 lg:grid-cols-[360px_1fr]">
      <div className="space-y-2" data-testid="admin-chats-list">
        {rows.map((r) => (
          <button key={r.booking_id} onClick={() => setSelId(r.booking_id)} data-testid={`admin-chat-${r.booking_id}`}
            className={`w-full rounded-xl border p-4 text-left transition-colors ${selId === r.booking_id ? "border-[#0D3B2B] bg-[#F3EDDC]" : "border-[#E3E6DD] bg-white hover:border-[#2E9E6B]"}`}>
            <div className="flex items-center justify-between"><b className="text-sm">{r.booking_id}</b>{r.waiting && <span className="rounded-full bg-[#E05C3A] px-2 py-0.5 text-[10px] font-bold text-white">Needs reply</span>}</div>
            <p className="text-xs text-[#6B7F74]">{r.customer}{r.staff && ` · ${r.staff}`}</p>
            <p className="mt-1 truncate text-sm">{r.messages[r.messages.length - 1].text}</p>
            <p className="text-[10px] text-[#6B7F74]">{fmtDateTime(r.last_at)}</p>
          </button>
        ))}
        {!rows.length && <Empty>No pickup chats yet.</Empty>}
      </div>
      {sel ? (
        <div className="space-y-4 rounded-2xl border border-[#E3E6DD] bg-white p-5" data-testid="admin-chat-detail">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div><p className="ks-serif text-2xl text-[#0D3B2B]">{sel.booking_id}</p>
              <button onClick={() => open({ type: "customer", id: sel.user_id, title: sel.customer })} className="text-sm font-bold text-[#2E9E6B] underline" data-testid="chat-open-360">{sel.customer} · view 360</button></div>
            <div className="flex items-center gap-2"><StatusBadge status={sel.status} /><ContactButtons mobile={sel.mobile} testid="chat" /></div>
          </div>
          <BookingChat key={sel.booking_id} messages={sel.messages} postUrl={`/admin/bookings/${sel.booking_id}/messages`} me="support" onSent={load} testid="admin-chat-thread" />
        </div>
      ) : <Empty>Select a conversation.</Empty>}
    </div>
  );
};
